import { styled } from '@mui/material';
import { ChipField } from 'react-admin';
import { UserActionTypeColorKey } from 'themes/statusColors';

type Size = 'm' | 'l';

export type IconProps = {
  size: Size;
  status?: UserActionTypeColorKey;
};

const sizeConfig: Record<Size, string> = {
  m: '16px',
  l: '18px',
};

export const UserActionTypeIcon = styled('div')<IconProps>(({ theme, size, color }) => ({
  height: sizeConfig[size],
  width: sizeConfig[size],
  borderRadius: '100%',
  backgroundColor: color
    ? theme.palette.status.userActionType?.[color as UserActionTypeColorKey]
    : theme.palette.divider,
}));

export const UserActionTypeChipFieldStyled = styled(ChipField)({
  margin: '0 !important',
  height: '24px',
});
